import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import { ifDefined } from 'lit/directives/if-defined.js';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from '@webs/components-library/theming';

@customElement('webs-logo-cloud')
export class LogoCloud extends LitElement {

  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    containerStyles,
    typographyStyles,
    css`
      .m-logo-cloud ::slotted([slot="title"]) {
        text-align: center !important;
        max-width: 767px !important;
        margin: 0 auto 1.5rem !important;
      }

      .m-logo-cloud .logos {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0rem auto -0.8rem;
      }

        ::slotted(*)  {
        background: #FFFFFF;
        margin-bottom: 0.8rem;
      }
    `]

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property()
  id: string;

  protected render(): unknown {
    return html`
    <section id="${ifDefined(this.id)}" class="m-logo-cloud ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
      <div part="container" class="container">
        <slot name="title"></slot>
        <div class="logos">
          <slot name="logo"></slot>
        </div>
      </div>
    </section>
    `
  }
}
